/* eslint-disable react/prop-types */
import React from 'react';

import BadesulSelect from './Select';
import BadesulCheckBox from './CheckBox';
import BadesulProofOfCivilStatus from './ProofOfCivilStatus';
import BadesulUpload from './Upload';
import BadesulDivider from './Divider';
import BadesulInput from './Input';
import BadesulNaturality from './Naturality';

const sizeMap = {
  '1/3': {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 8,
  },
  '2/3': {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 16,
  },
  '1/2': {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
  },
  1: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
  },
};

const BadesulInputHandler = ({
  input,
  loading,
  selectedBusinessUser,
  business,
  onUpdate,
  mutations,
  form,
  inputsFromDatabase,
}) => {
  if (input.divider) {
    return <BadesulDivider sizeMap={sizeMap} />;
  }

  if (input.withCustomRender === 'TermCard') {
    return (
      <BadesulProofOfCivilStatus
        input={input}
        loading={loading}
        selectedBusinessUser={selectedBusinessUser}
        business={business}
        sizeMap={sizeMap}
      />
    );
  }

  if (input.type === 'naturality') {
    return (
      <BadesulNaturality
        input={input}
        loading={loading}
        selectedBusinessUser={selectedBusinessUser}
        sizeMap={sizeMap}
      />
    );
  }

  if (input.type === 'checkbox') {
    return (
      <BadesulCheckBox input={input} loading={loading} onUpdate={onUpdate} sizeMap={sizeMap} />
    );
  }

  if (input.size === 'document') {
    return (
      <BadesulUpload
        input={input}
        loading={loading}
        selectedBusinessUser={selectedBusinessUser}
        saveBusinessUser={mutations.saveBusinessUser}
        form={form}
        sizeMap={sizeMap}
      />
    );
  }

  if (input.options || input.optionsFromDatabase) {
    return (
      <BadesulSelect
        input={input}
        loading={loading}
        onUpdate={onUpdate}
        inputsFromDatabase={inputsFromDatabase}
        sizeMap={sizeMap}
      />
    );
  }

  return (
    <BadesulInput
      input={input}
      loading={loading}
      postalCodeToAddress={mutations.postalCodeToAddress.mutation}
      sizeMap={sizeMap}
    />
  );
};

export default BadesulInputHandler;
